import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {useSystemContext} from '@homeaway/catalyst-globalization-configuration';
import {evaluateExperimentAndLog} from '@homeaway/abacus-client-utils';
import {MesoAdsContextWithTripDetails} from '@homeaway/react-meso-ads';

import getMesoContext from '../../selectors/mesoContext';
import {evaluateExperiment} from '../../utils/abacusHelper';
import {MESO_VRBO_DISPLAY_ADS, VRBO_MESO_HOUSE_ADS} from '../../abacus/experiments';

const MesoAdsContextProvider = ({children, ...rest}) => {
    const {isDesktop} = useSystemContext();
    const isAdsEnabled = isDesktop && evaluateExperiment({name: MESO_VRBO_DISPLAY_ADS, variant: 1});
    const houseAdExperiment = evaluateExperimentAndLog(VRBO_MESO_HOUSE_ADS);

    return (
        <MesoAdsContextWithTripDetails
            {...rest}
            isAdsEnabled={isAdsEnabled}
            cmptst={
                houseAdExperiment
                    ? `${houseAdExperiment.experimentKey.experimentId}.${houseAdExperiment.value}`
                    : ''
            }
        >
            {children}
        </MesoAdsContextWithTripDetails>
    );
};

MesoAdsContextProvider.propTypes = {
    havId: PropTypes.string.isRequired,
    gaiaId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    brandId: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    details: PropTypes.shape({
        adults: PropTypes.number,
        children: PropTypes.number,
        arriveDate: PropTypes.string,
        departDate: PropTypes.string
    })
};
const mapStateToProps = (state) => getMesoContext(state);
export default connect(mapStateToProps)(MesoAdsContextProvider);
